import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImages2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconImages2"><Path d="M14.5 7C13.1193 7 12 8.11929 12 9.5C12 10.8807 13.1193 12 14.5 12C15.8807 12 17 10.8807 17 9.5C17 8.11929 15.8807 7 14.5 7Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM5 13.5858L8 10.5858L16.4142 19H19V5H5V13.5858Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImages2;
